import React from 'react';
import {
  translate,
  BooleanField,
  Datagrid,
  DateField,
  DateInput,
  Delete,
  Edit,
  Filter,
  FormTab,
  List,
  LongTextInput,
  NullableBooleanInput,
  NumberField,
  ReferenceManyField,
  TabbedForm,
  TextField,
  TextInput,
  BooleanInput,
  NumberInput,
  downloadCSV
} from 'react-admin';
import { unparse as convertToCSV } from 'papaparse/papaparse.min';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Business from '@material-ui/icons/Business';
import {
  CardActions,
  CreateButton,
  ExportButton,
  RefreshButton
} from 'react-admin';
import Button from '@material-ui/core/Button';
import SegmentsInput from './SegmentsInput';
import SegmentsField from './SegmentsField';
import Header from './Header';
import LinkToUsers from '../users/LinkToUsers';
export const BusinessIcon = Business;

const BusinessFilter = props => (
  <Filter {...props}>
    <TextInput source="search" label="Name or comment" />
    <TextInput source="countries" />
    <TextInput source="industries" />
    <DateInput source="from_trough" />
    <DateInput source="to_trough" />
    <NumberInput source="licence_count" label="Licence Count <=" />
    <NumberInput source="user_count" label="Number of Users >=" />
    <NumberInput source="game_count" label="Number of Games >=" />
    <DateInput source="created_at_gte" label="Created After" />
    <DateInput source="created_at_lte" label="Created Before" />
    <BooleanInput source="is_active_game" label="Played Games" />
    <BooleanInput source="priorities" label="Has Priority" />
    <SegmentsInput />
  </Filter>
);

const exporter = businesses => {
  const header = [
    'Name',
    'Licence',
    'Good trough',
    'Business Type',
    'Games',
    'Users',
    'Country',
    'Industry',
    'Created At',
    'Priority'
  ];

  const businessesForExport = [
    ['Business', document.getElementById('total_business').value],
    ['Users', document.getElementById('total_users').value],
    ['Active Users', document.getElementById('total_active_users').value],
    ['Created Games', document.getElementById('total_games').value],
    ['Played Games', document.getElementById('total_played_games').value],
    ['Teams', document.getElementById('total_teams').value],
    [],
    header
  ];

  businesses.map(business => {
    businessesForExport.push([
      business.name,
      business.licence_count,
      business.good_trough,
      business.business_type,
      business.number_of_games_created,
      business.number_of_users,
      business.country,
      business.industry,
      business.created_at
    ]);
  });

  const csv = convertToCSV({
    data: businessesForExport
  });

  downloadCSV(csv, 'businesses');
};

const customAction = (filters, filterValues) => {
  window.open(
    '/api/businesses.xls?filter=' +
      encodeURIComponent(JSON.stringify(filterValues), '_blank')
  );
  console.log('custom action ');
  console.dir(filterValues);
};

const PostActions = ({
  bulkActions,
  basePath,
  currentSort,
  displayedFilters,
  exporter,
  filters,
  filterValues,
  onUnselectItems,
  resource,
  selectedIds,
  showFilter,
  total
}) => (
  <CardActions>
    {bulkActions &&
      React.cloneElement(bulkActions, {
        basePath,
        filterValues,
        resource,
        selectedIds,
        onUnselectItems
      })}
    {filters &&
      React.cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: 'button'
      })}

    <RefreshButton />
    {/* Add your custom actions */}
    {
      <Button
        color="primary"
        onClick={() => customAction(filters, filterValues)}
      >
        Download excel
      </Button>
    }
  </CardActions>
);

const BusinessPagination = ({ page, perPage, total, setPage }) => {
  const nbPages = Math.ceil(total / perPage) || 1;
  const goPages = 10;
  return (
    nbPages > 1 && (
      <Toolbar>
        {page > 1 && (
          <span>
            {page != 1 && (
              <Button
                color="primary"
                key="prev"
                icon={<ChevronLeft />}
                onClick={() => setPage(1)}
              >
                First
              </Button>
            )}
            {page - goPages > 0 && (
              <Button
                color="primary"
                key="prev"
                icon={<ChevronLeft />}
                onClick={() => setPage(page - goPages)}
              >
                Prev({goPages})
              </Button>
            )}
            <Button
              color="primary"
              key="prev"
              icon={<ChevronLeft />}
              onClick={() => setPage(page - 1)}
            >
              Prev
            </Button>
          </span>
        )}
        <Typography variant="body1">
          {page <= nbPages && page + '/' + nbPages}
        </Typography>
        {page !== nbPages &&
          page <= nbPages && (
            <span>
              <Button
                color="primary"
                key="next"
                icon={<ChevronRight />}
                onClick={() => setPage(page + 1)}
                labelPosition="before"
              >
                Next
              </Button>
              {page + goPages <= nbPages && (
                <Button
                  color="primary"
                  key="next"
                  icon={<ChevronRight />}
                  onClick={() => setPage(page + goPages)}
                  labelPosition="before"
                >
                  Next({goPages})
                </Button>
              )}
              {page != nbPages && (
                <Button
                  color="primary"
                  key="next"
                  icon={<ChevronRight />}
                  onClick={() => setPage(nbPages)}
                  labelPosition="before"
                >
                  Last
                </Button>
              )}
            </span>
          )}
      </Toolbar>
    )
  );
};

export const BusinessList = ({ permissions, ...props }) => (
  <div>
    <Header {...props} />
    <List
      {...props}
      pagination={<BusinessPagination />}
      filters={<BusinessFilter />}
      exporter={exporter}
      actions={<PostActions permissions={permissions} />}
    >
      <Datagrid>
        <TextField source="name" />
        <NumberField source="licence_count" label="Licence" />
        <DateField source="good_trough" type="date" />
        <SegmentsField />
        <NumberField source="number_of_games_created" label="Games" />
        <NumberField source="number_of_played_games" label="Played Games" />
        <NumberField source="number_of_active_users" label="Active Users" />
        <LinkToUsers />
        <TextField source="country" />
        <TextField source="industry" />
        <DateField source="created_at" type="date" />
        <TextField source="priority" label="Priority" />
      </Datagrid>
    </List>
  </div>
);



// WEBPACK FOOTER //
// ./src/business/index.js